import { FC } from 'react'

export interface MoreIconProps {
    color: string
}

export const MoreIcon: FC<MoreIconProps> = ({color}) => {

    return (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="1" x2="13" y2="1" stroke={color} strokeWidth="2" />
            <line y1="7" x2="19" y2="7" stroke={color} strokeWidth="2" />
            <line x1="6" y1="13" x2="19" y2="13" stroke={color} strokeWidth="2" />
        </svg>

    )
}